import { Box } from "@mui/material";
import React from "react";
import { createPortal } from "react-dom";

interface ChartHoverTooltipProps {
  active?: boolean;
  coordinate?: { x: number; y: number };
  containerRef: React.RefObject<HTMLElement | null>;
  width?: number;
  height: number;
  children: React.ReactNode;
}

export const ChartHoverTooltip: React.FC<ChartHoverTooltipProps> = ({
  active,
  coordinate,
  containerRef,
  width = 250,
  height,
  children,
}) => {
  const chartBounds = containerRef.current?.getBoundingClientRect();

  if (!active || !coordinate || !chartBounds || typeof document === "undefined") {
    return null;
  }

  const inset = 8;
  const pointX = chartBounds.left + coordinate.x;
  const pointY = chartBounds.top + coordinate.y;
  const left = Math.min(
    Math.max(pointX - width / 2, chartBounds.left + inset),
    chartBounds.right - width - inset,
  );
  const top =
    pointY - height - 12 >= chartBounds.top + inset
      ? pointY - height - 12
      : Math.min(pointY + 12, chartBounds.bottom - height - inset);

  return createPortal(
    <Box
      sx={{
        width,
        borderRadius: 2,
        bgcolor: "#001F3F",
        color: "common.white",
        px: 2.5,
        py: 1.75,
        boxShadow: 6,
        position: "fixed",
        left,
        top,
        zIndex: (theme) => theme.zIndex.tooltip,
        pointerEvents: "none",
      }}
    >
      {children}
    </Box>,
    document.body,
  );
};
